import { httpPost } from "shared/api/apiHandler";
import { AuthMethod } from "shared/constants/enums";
import BooleanResponseWithErrors from "shared/models/booleanResponseWithErrors";
import IVerificationCodeResponse from "shared/models/verificationCodeResponse";
import urls from "./urls";

export const requestAuthCode = async (
    email: string,
    authMethod: AuthMethod,
    returnLink?: string | null
): Promise<IVerificationCodeResponse> => {
    const data = {
        email,
        authMethod,
        returnLink,
    };
    const result = await httpPost<IVerificationCodeResponse>(
        window.APP_SETTINGS.spaceStoneApiBaseUri,
        urls.AUTH.REQUEST_LOGIN_CODE,
        data,
        undefined
    );

    return result;
};

export const resendLoginExpiredLink = async (
    token: string,
    returnLink?: string
): Promise<BooleanResponseWithErrors> => {
    const data = { token, returnLink };
    const result = await httpPost<BooleanResponseWithErrors>(
        window.APP_SETTINGS.spaceStoneApiBaseUri,
        urls.AUTH.RESEND_LOGIN_EXPIRED_LINK,
        data
    );

    return result.data;
};

export const resendChangeEmailLink = async (token: string): Promise<BooleanResponseWithErrors> => {
    const data = { token };
    const result = await httpPost<BooleanResponseWithErrors>(
        window.APP_SETTINGS.spaceStoneApiBaseUri,
        urls.ACCOUNT.RESEND_CHANGE_EMAIL_LINK,
        data
    );

    return result.data;
};

export const resendInvitationLink = async (
    invitationToken: string,
    returnLink?: string
): Promise<BooleanResponseWithErrors> => {
    const data = { invitationToken, returnLink };
    const result = await httpPost<BooleanResponseWithErrors>(
        window.APP_SETTINGS.spaceStoneApiBaseUri,
        urls.ACCOUNT.RESEND_INVITATION_LINK,
        data
    );

    return result.data;
};
